// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_EntregasKpisResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/entregas/kpis
 *
 * Five aggregated counts for the /pdv/entregas page: items expected today+next
 * 2 days, delayed, rescheduled, pending pickup notifications, and pending delivery.
 * Wire shape is a flat int-keyed Record (not a Row list).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_EntregasKpisResponseDados {
today_and_next_2_days: number
delayed: number
rescheduled: number
pending_alerts: number
pending_delivery: number
}

export type Orders_EntregasKpisResponse = ApiResponse<Orders_EntregasKpisResponseDados>;

registerResponseContract('Orders_EntregasKpisResponse', {
  today_and_next_2_days: { type: 'number',  required: true },
  delayed:               { type: 'number',  required: true },
  rescheduled:           { type: 'number',  required: true },
  pending_alerts:        { type: 'number',  required: true },
  pending_delivery:      { type: 'number',  required: true },
})
